import React from 'react'
import CareersHero from './section/CareersHero.js'
import CareersCards from './section/CareersCards.js'
import CareersPositions from './section/CareersPositions.js'

const Careers = () => {
  return (
    <>
   <CareersHero/>
   <CareersCards/>
   <CareersPositions/>
   </>
  )
}

export default Careers